(() => {
  const triggerSelector = '.wishlist-hero-header-icon';
  const modalSelector = '.MuiDialog-root .wishlist-hero-header-title';
  const idleClass = 'jdc-wishlist-header-idle';
  const mobileQuery = window.matchMedia('(max-width: 1023px)');
  let modalWasOpen = false;

  const getTrigger = () => document.querySelector(triggerSelector);

  const resetTrigger = () => {
    const trigger = getTrigger();

    if (!trigger) return;

    if (!mobileQuery.matches) {
      trigger.classList.remove(idleClass);
      return;
    }

    trigger.classList.add(idleClass);

    if (document.activeElement === trigger) {
      trigger.blur();
    }
  };

  const releaseTrigger = (event) => {
    const trigger = event.target.closest && event.target.closest(triggerSelector);

    if (trigger && mobileQuery.matches) {
      trigger.classList.remove(idleClass);
    }
  };

  const checkModalState = () => {
    const modalIsOpen = Boolean(document.querySelector(modalSelector));

    if (modalIsOpen) {
      modalWasOpen = true;
      return;
    }

    if (!modalWasOpen) return;

    modalWasOpen = false;

    window.requestAnimationFrame(resetTrigger);
    window.setTimeout(resetTrigger, 120);
    window.setTimeout(resetTrigger, 400);
  };

  const init = () => {
    document.addEventListener('pointerdown', releaseTrigger, true);
    document.addEventListener('touchstart', releaseTrigger, {
      capture: true,
      passive: true,
    });

    const observer = new MutationObserver(checkModalState);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', resetTrigger);
    } else {
      mobileQuery.addListener(resetTrigger);
    }

    checkModalState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
